import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
// import axios from 'axios';
import { _axios } from '../../utils/axios';

const CreateAds = ({ show, onHide }) => {
    const [formData, setFormData] = useState({
        androidAdvId: false,
        iosAdvId: false,
        androidAdvIdValue: '',  // Add this for manual input
        iosAdvIdValue: '',      // Add this for manual input
        adType: '',
        location: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            // Validate required fields
            if (!formData.androidAdvId && !formData.iosAdvId) {
                toast.error('Please select at least one advertisement ID type');
                setIsSubmitting(false);
                return;
            }

            if (!formData.adType) {
                toast.error('Please select an ad type');
                setIsSubmitting(false);
                return;
            }

            if (!formData.location) {
                toast.error('Please select a location');
                setIsSubmitting(false);
                return;
            }

            if (formData.androidAdvId && !formData.androidAdvIdValue) {
                toast.error('Please enter Android Advertisement ID');
                setIsSubmitting(false);
                return;
            }
            
            if (formData.iosAdvId && !formData.iosAdvIdValue) {
                toast.error('Please enter iOS Advertisement ID');
                setIsSubmitting(false);
                return;
            }

            // Prepare data for API
            const apiData = {
                android_adv_id: formData.androidAdvId ? formData.androidAdvIdValue : null,
                ios_adv_id: formData.iosAdvId ? formData.iosAdvIdValue : null,
                ad_type: formData.adType,
                location: formData.location
            };

            const response = await _axios.post(`${ServerPath}/advertisements/create`, apiData);

            if (response.data.success) {
                setIsSubmitted(true);
                toast.success('Advertisement created successfully');
                setTimeout(() => {
                    onHide();
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(response.data.message || 'Failed to create advertisement');
                setIsSubmitting(false);
            }
        } catch (error) {
            console.error('Error creating advertisement:', error);
            toast.error(error.response?.data?.message || 'Failed to create advertisement');
            setIsSubmitting(false);
        }
    };

    // Reset form when closing modal
    const handleClose = () => {
        setFormData({
            androidAdvId: false,
            iosAdvId: false,
            androidAdvIdValue: '',
            iosAdvIdValue: '',
            adType: '',
            location: ''
        });
        setIsSubmitting(false);
        setIsSubmitted(false);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            centered
            style={{ borderRadius: '10px' }}
        >
            <div style={{ borderRadius: '10px' }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                    <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>Create Ads</Modal.Title>
                    <div className="ms-auto d-flex align-items-center">
                        <span style={{ color: '#666', fontSize: '14px', marginRight: '38px' }}>Last Update On</span>
                        <span style={{ color: '#999', fontSize: '14px', marginRight: '38px' }}>NA</span>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: '24px' }}>
                    <Form>
                        <div className="row mb-4">
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        id="androidAdvId"
                                        label={<span>Android Adv ID <span className="text-danger">*</span></span>}
                                        name="androidAdvId"
                                        checked={formData.androidAdvId}
                                        onChange={handleCheckboxChange}
                                        style={{ fontSize: '16px' }}
                                    />
                                    {formData.androidAdvId && (
                                        <Form.Control
                                            type="text"
                                            name="androidAdvIdValue"
                                            value={formData.androidAdvIdValue}
                                            onChange={handleInputChange}
                                            placeholder="Enter Android ID"
                                            className="mt-2"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    )}
                                </Form.Group>
                            </div>
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        id="iosAdvId"
                                        label={<span>iOS Adv ID <span className="text-danger">*</span></span>}
                                        name="iosAdvId"
                                        checked={formData.iosAdvId}
                                        onChange={handleCheckboxChange}
                                        style={{ fontSize: '16px' }}
                                    />
                                    {formData.iosAdvId && (
                                        <Form.Control
                                            type="text"
                                            name="iosAdvIdValue"
                                            value={formData.iosAdvIdValue}
                                            onChange={handleInputChange}
                                            placeholder="Enter iOS ID"
                                            className="mt-2"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    )}
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Ad Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="adType"
                                        value={formData.adType}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="" disabled>Select Ads</option>
                                        <option value="Banner Ads">Banner Ads</option>
                                        <option value="Interstitial Ads">Interstitial Ads</option>
                                        <option value="Rewarded Interstitial Ads">Rewarded Interstitial Ads</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Location <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="location"
                                        value={formData.location}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <option value="" disabled>Select location</option>
                                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                                        <option value="Gujarat">Gujarat</option>
                                        <option value="Maharashtra">Maharashtra</option>
                                        <option value="All">All</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>

                <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isSubmitting || isSubmitted}
                        style={{
                            backgroundColor: '#5662F6',
                            borderColor: '#5662F6',
                            borderRadius: '6px',
                            padding: '10px 40px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </Modal>
    );
}


export default CreateAds;